export const PROJECT = 1
export const COMPANY = 2
export const INVOICE = 3
export const RECEIPT = 4
export const MAIN = 5
